import React from 'react';
import { ArrowUp } from 'lucide-react';
import { footerLinks } from '../../data/mock';

const Footer = () => {
  return (
    <footer style={{ background: '#FFFFFF', color: '#12367F' }} className="border-t border-[#12367F]/15">
      <div className="container-x px-6 pt-16 md:pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <svg
                viewBox="0 0 22.5124 22.1608"
                width={72}
                height={72}
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                className="shrink-0"
                style={{ color: '#12367F' }}
              >
                <path
                  d="M13.2435 1.09505L21.056 8.90755C22.5013 10.3529 22.5111 11.7884 21.0853 13.2142L13.224 21.0853C11.7884 22.5111 10.3626 22.5013 8.91731 21.056L1.09505 13.2337C-0.350264 11.7884-0.369795 10.3626 1.06575 8.92708L8.93685 1.06575C10.3724-0.369795 11.7982-0.350264 13.2435 1.09505ZM8.58528 7.57942L8.58528 14.5814C8.58528 15.0697 9.12239 15.2943 9.59114 15.0111L15.3236 11.6322C15.7435 11.3783 15.7337 10.7923 15.3236 10.5482L9.59114 7.14974C9.16145 6.89583 8.58528 7.10091 8.58528 7.57942Z"
                  fill="currentColor"
                />
              </svg>
              <p className="font-display uppercase text-4xl md:text-6xl leading-none whitespace-nowrap" style={{ color: '#12367F' }}>
                Nasu Group
              </p>
            </div>
            <p className="mt-6 max-w-md text-[#12367F]/75">
              From managing talent and crafting game-changing creator strategies to producing
              scroll-stopping content, we offer end-to-end influencer marketing services Both UK
              and USA brands trust.
            </p>
            <div className="mt-4 max-w-md text-[#12367F]/75 space-y-1">
              <p>128 City Road, London, United Kingdom, EC1V 2NX</p>
              <p>
                1309 Coffeen Avenue STE 19305
                <br />
                Sheridan, Wyoming 82801
              </p>
            </div>
            <a href="/contact" className="btn-base btn-primary mt-6">
              Book a free strategy session
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm">
            {Object.entries(footerLinks).map(([key, group]) => (
              <div key={key}>
                <p className="font-semibold uppercase tracking-wider text-xs text-[#12367F]/60 mb-4">
                  {group.label}
                </p>
                <ul className="space-y-3">
                  {group.items.map((i) => (
                    <li key={i.label}>
                      <a href={i.href} className="text-[#12367F] hover:text-[#12367F]/60 transition-colors">
                        {i.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#12367F]/15 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between text-sm">
          <p className="text-[#12367F]/70">© 2026 Nasu Group. All rights reserved.</p>
          <div className="flex flex-wrap gap-6 text-[#12367F]/80">
            <a href="/terms-of-service" className="hover:text-[#12367F]">Terms & Conditions</a>
            <a href="/privacy-policy" className="hover:text-[#12367F]">Privacy Policy</a>
            <a href="/cookie-policy" className="hover:text-[#12367F]">Cookie Policy</a>
          </div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#12367F]/30 hover:bg-[#12367F] hover:text-white transition-colors"
          >
            Back to top <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
